import React, { useState } from 'react'
import { makeStyles, Snackbar, SnackbarOrigin, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useTranslation } from 'react-i18next'
import { dashboardStyles } from './DashboardStyles'
import { useIsSuperAdmin } from '../../utils/tenantFilter'
import MyAccount from './MyAccount'
import TenantInfo from './TenantInfo'
import Reports from './Reports'
import Markets from './Markets'
import TenantOverview from './TenantOverview'
import { HALVES_GAP } from './DashboardSection'

const useLayoutStyles = makeStyles((theme) => ({
    halves: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        columnGap: HALVES_GAP,
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: '1fr 1fr',
        },
    },
}))

export default function Dashboard() {
    const { t } = useTranslation()
    const classes = dashboardStyles()
    const layout = useLayoutStyles()
    const isSuperAdmin = useIsSuperAdmin()
    const [errorMessage, setErrorMessage] = useState<string>()
    const [successMsg, setSuccessMsg] = useState<string>()

    const snackBar = (msg: string, onClose: () => void, type: 'error' | 'success') => {
        const position =
            type === 'success'
                ? { vertical: 'top', horizontal: 'center' }
                : { vertical: 'bottom', horizontal: 'center' }
        return (
            <Snackbar anchorOrigin={position as SnackbarOrigin} open={true} autoHideDuration={5000} onClose={onClose}>
                <Alert onClose={onClose} severity={type}>
                    {msg}
                </Alert>
            </Snackbar>
        )
    }

    const showSuccess = (msg: string) => {
        setErrorMessage(undefined)
        setSuccessMsg(msg)
    }

    return (
        <div className={classes.page}>
            <Typography align="left" variant="h3" className={classes.title}>
                {t('dashboard.title')}
            </Typography>

            {isSuperAdmin ? (
                <>
                    <div className={layout.halves}>
                        <MyAccount onSuccess={showSuccess} onError={setErrorMessage} />
                        <Markets editable onSuccess={showSuccess} onError={setErrorMessage} />
                    </div>
                    <TenantOverview onSuccess={showSuccess} onError={setErrorMessage} />
                </>
            ) : (
                <>
                    <div className={layout.halves}>
                        <MyAccount onSuccess={showSuccess} onError={setErrorMessage} />
                        <TenantInfo onSuccess={showSuccess} onError={setErrorMessage} />
                    </div>
                    <Reports />
                </>
            )}

            {errorMessage && snackBar(errorMessage, () => setErrorMessage(undefined), 'error')}
            {successMsg && !errorMessage && snackBar(successMsg, () => setSuccessMsg(undefined), 'success')}
        </div>
    )
}
